var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppDisconnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.713,
    height: 20.123,
    viewBox: "0 0 21.713 20.123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2365",
    "data-name": "Group 2365",
    transform: "translate(-412 -652)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_17456",
    "data-name": "Rectangle 17456",
    transform: "translate(412 652)",
    fill: "#fff",
    stroke: "#1d3378",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.695,
    height: 20.123,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 12.195,
    height: 18.623,
    rx: 2.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8070",
    "data-name": "Path 8070",
    d: "M12.219,3.609a2.273,2.273,0,0,0-.488.053,2.927,2.927,0,0,0,.027-.374A2.731,2.731,0,0,0,9.089.5,2.643,2.643,0,0,0,6.808,1.847a2.271,2.271,0,0,0-1.169-.326A2.4,2.4,0,0,0,3.3,3.653a2.267,2.267,0,0,0-.438-.044A2.417,2.417,0,0,0,.5,6.077,2.417,2.417,0,0,0,2.862,8.545h9.356a2.417,2.417,0,0,0,2.362-2.468A2.417,2.417,0,0,0,12.219,3.609Z",
    transform: "translate(418.382 656.066)",
    fill: "#fff",
    stroke: "#1d3378",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2217",
    "data-name": "Group 2217",
    transform: "translate(424.195 659.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8068",
    "data-name": "Path 8068",
    d: "M14.206,14.295l3,3",
    transform: "translate(-14.206 -14.295)",
    fill: "none",
    stroke: "#1d3378",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8069",
    "data-name": "Path 8069",
    d: "M0,0,3,3",
    transform: "translate(3) rotate(90)",
    fill: "none",
    stroke: "#1d3378",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8071",
    "data-name": "Path 8071",
    d: "M-13712.667-3594.555h11.91",
    transform: "translate(14125.652 4262.423)",
    fill: "none",
    stroke: "#1d3378",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_257",
    "data-name": "Ellipse 257",
    cx: 0.652,
    cy: 0.652,
    r: 0.652,
    transform: "translate(418.521 668.862)",
    fill: "#1d3378"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppDisconnected);
export default __webpack_public_path__ + "static/media/app_disconnected.4b9bd74a3e3c547f52eb66ab59ef0855.svg";
export { ForwardRef as ReactComponent };